export const content = {
    base_info: {

    },
    menu: {
        item: ['ABOUT', 'PRODUCTS', 'DESIGN', 'STORE', 'CONTACT']
    },
    footer: [
        'by TRAYTON GROUP',
        'copy right',
        '@2019-2029​'
    ],
    home: {
        topTitle: 'PURE HAPPINESS FROM DENMARK',
        about: 'ABOUT',
        list: [
            ['SOFA', 'EXPLORE MORE'],
            ['BED', 'EXPLORE MORE'],
            ['CHAIR', 'EXPLORE MORE'],
            ['FURNITURE', 'EXPLORE MORE']
        ],
        panel: [
            ['AUTHENTIC DANISH', 'DESIGN', 'MADE IN CHINA', 'High-quality natural materials,', 'Crafted sanctuaries of tranquillity and joy,', 'More than juxtaposition of colours and fabrics', 'Get Inspired '],
            ['VISIT STORES TO GET', 'CUSTOMIZED DESIGN SERVICE', 'Every product stands the test', 'of time Celebrated through', 'timeless elegance and functional beauty', 'Contact us']
        ],
        content: [
            [
                'Creating Style, Hygge & Happiness',
                'Our product designs and spaces are tailored to enrich the living space with an aura of cosiness and luxurious tranquility, creating happiness.',
                "The Danish term 'Hygge' is the soul of NEST. The plush textures, colors, genuine leather, resilient fabrics, and supportive contours are all carefully selected to enhance the feeling of comfort and ease.",
                'We believe in creating spaces that foster warmth and encourage people to stay a little longer, share stories, and laugh together.'],
            [
                'PURE HAPPINESS FROM DENMARK',
                'NEST infuses your home with the serenity of authentic Danish design and style, elevating comfort and improving life in the city for a modern generation.',
                'Our products are crafted sanctuaries of tranquillity and joy, celebrated through timeless elegance and functional beauty.']
        ],
    },
    design: {
        topTitle: 'DESIGN & CRAFTMANSHIP',
        tPanel: ['NOORUM DANISH DESIGNER TEAM', "NEST's product development and design innovation comes from Denmark's excellent home designers.They are young and passionate about their work.They also have rich creativity and imagination. On the basis of exploring new technologies, new materials and new lifestyles, they have created many modern Danish designed home products. However, what is more important is our interpretation of Danish design: simplicity, elegance, functionality and durability."],
        content: [
            [
                'AUTHENTIC DANISH DESIGN',
                'The timeless aesthetics of Danish craftsmanship inspire our collections.',
                'The clean lines, functional approach, and minimalist beauty inherent in our living, sleeping and dining collections reflect a heritage of design that prizes simplicity and elegance.',
                'Each product is a piece of art, conceived in the minds of visionary Danish designers and brought to life through skilled hands.'
            ],
            [
                'NATURAL MATERIALS',
                'Natural leathers / Natural woods (tables &',
                'chairs) / Natural stone (tables)',
                'Hardwood & plywood frames (sofas)',
                'EU zero formaldehyde',
                'Low emission foam & fibers',
                'Carbon neutral manufacturing',
            ],
            [
                'WORLD CLASS COMFORT',
                'World standard',
                'ergonomic engineering',
                'High resilience foam',
                'Top grade hollow',
                'conjugated polyester',
                'fibers',
                'Feather filled cushion top',
                'Motion multi functions &',
                'lumbar support',
                'Lifelong frame durability'
            ]
        ]
    },
    contact: {
        topTitle: 'CONTACT',
        email: {
            title: 'SEND US A MESSAGE',
            placeholder: [
                'Your country/city',
                'Where did you learn about us？',
                'Your Name',
                'Email',
                'Phone Number',
                'Your Message',
                'SUBMIT'
            ]
        }
    },
    about: {
        topTitle: 'BRAND STORY',
        content: [
            [
                'NEST Space founded by Danish entrepreneur Simon Lichtenberg.',
                'Simon moved to Shanghai in 1993 and brought Nordic design furniture to China as the first and has had essential impact on Chinese furniture design and has continued to lead and innovated in design, modernization, digitalization and sustainable manufacturing in the Chinese furniture industry being one of the most efficient and sustainable manufacturer of furniture in the world.',
                'Simon Lichtenberg',
                ' Founder & CEO'
            ],
            [
                'OUR FACILITIES​',
                'We have offices in High Point, North Carolina (US), Guadalajara (Mexico), Ho Chi Minh City (Vietnam), Hong Kong, Shanghai, Jiashan & Jiaxing (China). We employ around 2,000 people, and own and operate 4 factories with a total of 200,000m2 of manufacturing floors in China, Vietnam and Mexico. We have one of the highest rates of productivity per worker in the industry, and one of the best records regarding quality and delivery.'
            ],
            [
                'THE NEST SPACE BRAND NEST​',
                'NEST SPACE® is the our main international brand comprising of furniture for living, sleeping',
                "and dining, with a core of quality leather and fabric upholstery designed and manufactured in China and distributed through leading retailers across the globe. The brand was established in 2020 and is focused on developing, marketing and distributing expertly designed modern furniture with a Nordic heritage. NEST SPACE® upholstery products are all manufactured in-house at the Trayton Furniture main plant in Xiuzhou, Jiaxing, China and we offer colour customisation ‘made to order’ in both leathers and fabrics with a short delivery time.",
                'We run our own retail network of NEST SPACE® stores globally, both company owned and franchised, targeting the fast growing modern urban mid-market segment.',
            ],
            [
                'R&D CAPABILITIES​',
                'Over our 30 years of sofa making we have developed and refined unique and effective methods of research, conception, design & engineering for new product development processes and competencies. We have been successful in using the newest and most modern and efficient 3D digital tools in a fast, standardized, well-structured R&D process. We engineer our products with the goal of producing the highest quality products that offer the best value for money in the industry, using the most advanced technology.',
                'QUALITY & ATTENTION TO DETAIL​',
                'Creating the best skilled sewing and upholstery teams and the most stylish upholstery lines in the industry has always been one of our key differentiators and remains an area in which we take great pride. We achieve these high standards through relentless and continuous improvement of tools, production layout, process control, efficiency improvements, standardization, and automation.',
                'We have consistently maintained an industry-best quality level with a claim rate well below 0.5%',
            ],
            [
                'SUSTAINABILITY',
                'UNGC (UNITED NATIONS GLOBAL COMPACT)​',
                'In October 2023, at the "Forward Faster" CEO Roundtable held in Shanghai, China, Simon Lichtenberg, Founder and CEO of Trayton Group, met with Sanda Ojiambo, Assistant Secretary-General and Executive Director of the United Nations Global Compact (UNGC), to discuss the responsibilities and opportunities of businesses in global sustainable development.',
                'As one of the earliest Chinese companies to join the UNGC, Trayton Group successfully completed the SDG Innovation Accelerator for Young Professionals in 2023 and passed the Climate Ambition Accelerator (CAA) program in 2024, further deepening its commitment to sustainable development.',
                'SBTI (SCIENCE-BASED TARGETS INITIATIVE)​',
                'In May 2024, Trayton successfully obtained official verification from SBTi, becoming the first furniture company in China to achieve this certification. This milestone marks a significant step in Trayton’s climate action journey, reinforcing its commitment to science-based carbon reduction and sustainable development.',
            ]
        ]
    },
    video: {
        topTitle: 'STORE',
        title: 'We run our own retail network of NEST SPACE® stores globally, both company owned and franchised, targeting the fast growing modern urban mid-market segment.'
    },
    product: {
        topTitle: 'PRODUCTS',
    }
}